import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import Flex from "../../Generic/Flex";

interface Props {
  selectedDateTime: LocalDateTime | null;
  onClickApprove: () => void;
}

const TaskInstanceChangeFooter = (props: Props) => {
  const dateStr =
    props.selectedDateTime === null
      ? null
      : globalize().formatLocalDateTime(props.selectedDateTime, { datetime: "short" });

  return (
    <Flex direction="column" className="AvailableTaskFooter">
      <AppButton onClick={props.onClickApprove}>
        {dateStr === null
          ? translate(STRINGS.CHANGE_TASK_TIME)
          : translate(STRINGS.SCHEDULE_FOR).replace("{{date}}", dateStr)}
      </AppButton>
    </Flex>
  );
};

export default TaskInstanceChangeFooter;
